/**
 * Mobile sticky add-to-cart bar.
 * Shows once the shopper scrolls past the main product form, and its button
 * simply clicks the real add-to-cart button already on the page — it does
 * not submit its own form, so variant/quantity selection stays the single
 * source of truth.
 */
class StickyBuyBar extends HTMLElement {
  connectedCallback() {
    this.trigger = document.getElementById(this.dataset.observeId);
    this.primaryButton = document.querySelector(this.dataset.primaryButtonSelector);

    if (!this.trigger || !this.primaryButton) return;

    this.button = this.querySelector('[data-sticky-add-to-cart]');
    if (this.button) {
      this.button.addEventListener('click', () => {
        this.primaryButton.click();
      });
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.classList.toggle('sticky-buy-bar--visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      },
      { threshold: 0 }
    );
    this.observer.observe(this.trigger);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }
}

if (!customElements.get('sticky-buy-bar')) {
  customElements.define('sticky-buy-bar', StickyBuyBar);
}
